import _ from 'underscore';
import humps from 'humps';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import http from '../shared/http';

const DEFAULTS = {
  language: 'en',
  partnerType: 'Brand',
  navbarBackgroundColor: 'rgb(5, 0, 56)',
  navbarTextColor: 'rgb(99, 115, 133)',
  sites: [],
  adTypes: []
};

export class Partner {
  constructor(data = {}) {
    data = _.defaults(data, DEFAULTS);
    _.extend(this, data);
  }

  hasAdType(name) {
    return Boolean(this.getAdType(name));
  }

  getAdType(name) {
    return _.findWhere(this.adTypes, { name: name });
  }

  toggleAdTypes(adType) {
    const type = this.getAdType(adType);

    if (type) {
      this.adTypes = _.without(this.adTypes, type);
    } else {
      this.adTypes.push({ name: adType });
    }
  }
}

export const PartnerContext = React.createContext();

export const PartnerProvider = ({ children }) => {
  const [partner, setPartner] = useState(new Partner(DEFAULTS));
  useEffect(function fetchPartner() {
    const search = new URLSearchParams(window.location.search);
    const subdomain = search.get('subdomain');
    let url = '';
    if (subdomain) {
      url = `/partners/by_subdomain?subdomain=${subdomain}`;
    } else {
      url = '/partners/by_subdomain';
    }

    http.get(url).then(response => {
      const newPartner = new Partner(humps.camelizeKeys(response.data));
      newPartner.adTypes = newPartner.ad_types;
      setPartner(newPartner);
    });
  }, []);

  return (
    <PartnerContext.Provider value={partner}>
      {children}
    </PartnerContext.Provider>
  );
};

PartnerProvider.propTypes = {
  children: PropTypes.element.isRequired
};
